export class Permissions {
    static readonly ViewAllClients = 'ViewAllClients';
    static readonly ViewAllMinutes = 'ViewAllMinutes';
    static readonly ViewMyPortfolio = 'ViewMyPortfolio';
    static readonly CreateClient = 'CreateClient';
    static readonly UpdateClient = 'UpdateClient';
    static readonly UpdateOwnersDicom = 'UpdateOwnersDicom';
    static readonly CreateCompanyOwners = 'CreateCompanyOwners';
    static readonly UpdateCompanyOwners = 'UpdateCompanyOwners';
    static readonly DeleteCompanyOwners = 'DeleteCompanyOwners';
    static readonly CreateInvoiceOperation = 'CreateInvoiceOperation';
    static readonly UpdateMinutes = 'UpdateMinutes';
    static readonly ApproveMinutes = 'ApproveMinutes';
    static readonly RejectMinutes = 'RejectMinutes';
    static readonly CreateMinutes = 'CreateMinutes';
    static readonly ResoluteMinuteDebtors = 'ResoluteMinuteDebtors';
    static readonly ViewUsersManagement = 'ViewUsersManagement';
    static readonly AssignRolesToUser = 'AssignRolesToUser';
    static readonly RevokeRolesToUser = 'RevokeRolesToUser';
    static readonly ViewRolesManagement = 'ViewRolesManagement';
    static readonly AssignPermissionsToRole = 'AssignPermissionsToRole';
    static readonly RevokePermissionsToRole = 'RevokePermissionsToRole';
    static readonly CreateRoles = 'CreateRoles';
    static readonly ViewAllIssueWarranties = 'ViewAllIssueWarranties'
    static readonly ViewDebtors = "ViewDebtors";
    static readonly ViewSinAsignar = "ViewSinAsignar";
    static readonly ViewAllFactoringCompanies = 'ViewAllFactoringCompanies'
    static readonly GetNewSbifDebt = 'GetNewSbifDebt'
    static readonly ViewBtnSocios = 'ViewBtnSocios'
    static readonly ViewAllDebtors = 'ViewAllDebtors'
    static readonly ViewDebtorsConfig = 'ViewDebtorsConfig'
    static readonly ViewFactoringOpportunities = 'ViewOpportunities'
    static readonly ViewAlDocumentTypes = 'ViewAlDocumentTypes';
    static readonly ReviewMinuteSpecialCondition = 'ReviewMinuteSpecialCondition';
    static readonly ViewDealsCRM = 'ViewDealsCRM'
    static readonly ViewAllMinuteApprovalRules = 'ViewAllMinuteApprovalRules';
    static readonly RegisterMinuteApprovalRule = 'RegisterMinuteApprovalRule';
    static readonly UpdateMinuteApprovalRule = 'UpdateMinuteApprovalRule';
    static readonly EnableDisableMinuteApprovalRule = 'EnableDisableMinuteApprovalRule';
    static readonly ManageSalesQuotes = 'ManageSalesQuotes';
    
} 

